import React from "react";

interface LongFormSkeletonProps {
	className?: string;
}

const LongFormSkeleton: React.FC<LongFormSkeletonProps> = ({
	className = ""
}) => {
	return (
		<div className={`animate-pulse space-y-4 ${className}`}>
			{/* Header skeleton */}
			<div className="h-4 bg-primary-accent rounded w-1/4"></div>

			{/* Paragraph skeletons */}
			<div className="space-y-3">
				<div className="h-3 bg-primary-accent rounded w-full"></div>
				<div className="h-3 bg-primary-accent rounded w-full"></div>
				<div className="h-3 bg-primary-accent rounded w-4/5"></div>
			</div>

			<div className="space-y-3">
				<div className="h-3 bg-primary-accent rounded w-full"></div>
				<div className="h-3 bg-primary-accent rounded w-full"></div>
				<div className="h-3 bg-primary-accent rounded w-full"></div>
				<div className="h-3 bg-primary-accent rounded w-2/3"></div>
			</div>

			<div className="space-y-3">
				<div className="h-3 bg-primary-accent rounded w-full"></div>
				<div className="h-3 bg-primary-accent rounded w-full"></div>
				<div className="h-3 bg-primary-accent rounded w-full"></div>
				<div className="h-3 bg-primary-accent rounded w-3/5"></div>
			</div>

			{/* Final paragraph skeleton */}
			<div className="space-y-3">
				<div className="h-3 bg-primary-accent rounded w-1/6"></div>
				<div className="h-3 bg-primary-accent rounded w-1/3"></div>
			</div>

			{/* Loading text */}
			<div className="text-center pt-4">
				<div className="h-3 bg-primary-accent rounded w-48 mx-auto"></div>
			</div>
		</div>
	);
};

export default LongFormSkeleton;
